import { api } from '../utils/libs/axios'
import { NewFormPayloadSchema } from '../utils/types/form'

const getAll = async () => api('/v1/forms')

const getAllTemplates = async () => api('/v1/forms/templates')

const getSubmissions = async (formId: string) => api(`/v1/forms/${formId}/submissions`)

const getAllPublished = async () => api('/v1/forms/published')

const getOne = async (id: string) => api(`/v1/forms/${id}`)

const create = async (payload: NewFormPayloadSchema) => api.post('/v1/forms', payload)

const createTemplate = async (payload: NewFormPayloadSchema) =>
  api.post('/v1/forms/templates', payload)

const update = async (payload: NewFormPayloadSchema) => api.patch('/v1/forms', payload)

const updateTemplate = async (payload: NewFormPayloadSchema) =>
  api.patch('/v1/forms/templates', payload)

const publish = async ({ id, isPublished }: { id: string; isPublished: boolean }) =>
  api.patch(`/v1/forms/${id}/publish`, { isPublished })

const verifySubmit = async (id: string) => api(`/v1/forms/${id}/verify`)

const deleteOne = async (id: string) => api.delete(`/v1/forms/${id}`)

const deleteTemplate = async (id: string) => api.delete(`/v1/forms/templates/${id}`)

export const FormService = {
  getAll,
  getAllTemplates,
  getSubmissions,
  getAllPublished,
  getOne,
  create,
  createTemplate,
  update,
  updateTemplate,
  publish,
  verifySubmit,
  deleteOne,
  deleteTemplate
}
